import { Capacitor } from '@capacitor/core'
import { NativeBiometric } from '@capgo/capacitor-native-biometric'
import { BIOMETRY_TYPE } from '@/utils/biometrics'

const CREDENTIALS_SERVER = 'com.icreapptive.binnacle.biometric-login'

const UNAVAILABLE = { isAvailable: false, biometryType: BIOMETRY_TYPE.NONE }

export default {
  // Disponibilidad y tipo en una sola llamada nativa. El tipo hace falta para el icono: antes se
  // pedia solo el booleano y el boton mostraba huella tambien en dispositivos con Face ID.
  async getAvailability () {
    if (!Capacitor.isNativePlatform()) return UNAVAILABLE
    try {
      const result = await NativeBiometric.isAvailable()
      return {
        isAvailable: result.isAvailable,
        biometryType: result.biometryType || BIOMETRY_TYPE.NONE
      }
    } catch (error) {
      console.error(error)
      return UNAVAILABLE
    }
  },
  verifyIdentity (options) {
    return NativeBiometric.verifyIdentity({
      title: options.title,
      subtitle: options.subtitle,
      description: options.description
    })
  },
  setCredentials (username, password) {
    return NativeBiometric.setCredentials({
      username,
      password,
      server: CREDENTIALS_SERVER
    })
  },
  getCredentials () {
    return NativeBiometric.getCredentials({ server: CREDENTIALS_SERVER })
  },
  deleteCredentials () {
    return NativeBiometric.deleteCredentials({ server: CREDENTIALS_SERVER })
  }
}
